module.exports = __webpack_public_path__ + "static/media/12-rectangle-unavailable.843afa09.svg";